import React, { useEffect } from "react";
import "./App.css";
import AvailableEvents from "./components/AvailableEvents/AvailableEvents";
import config from "./config";

const App: React.FC = (props) => {
  const showEventsPage = () => {
    if (window.location.pathname === "/events") {
      return <AvailableEvents />;
    }
  };

  useEffect(()=>{
    
    if (window.location.pathname === "/" && sessionStorage.getItem('access_token') !== null) {
      window.location.pathname = `/events`;
    }
    else if (window.location.pathname === "/" || window.location.pathname === "/index.html") {
      window.location.href =
        `${config.TID_AUTHORIZE}?scope=openid%20${config.SCOPE}&response_type=code&redirect_uri=${config.REDIRECT_URL}&client_id=${config.CLIENT_ID}`;
    }
    setTimeout(()=>{
      sessionStorage.removeItem('access_token')
    },50*1000)
  },[])

  return (
    <>
      {showEventsPage()}
    </>
  );
};

export default App;
